module.exports = __webpack_public_path__ + "static/media/s_v10_26.e4f0a275.mp3";